import Icon from 'react-icon-base';

const IcHome = props => (
   <Icon viewBox='0 0 108.24 108.24' {...props}>
      <g id='Mode_Isolation' data-name='Mode Isolation'>
         <g stroke='currentColor' fill='none' stroke-width='3px' stroke-linecap='round'>
            <circle className='cls-2' cx='54.12' cy='54.12' r='52.62' stroke-linejoin='round' />
            <g stroke-miterlimit='10'>
               <path
                  className='cls-1'
                  d='M53.51,75.01h-16.74c-3.83,0-6.94-3.11-6.94-6.94v-34.74c0-3.83,3.11-6.94,6.94-6.94h28.83c3.83,0,6.94,3.11,6.94,6.94v13.86'
               />
               <line className='cls-1' x1='38.99' y1='35.99' x2='63.78' y2='35.99' />
               <line className='cls-1' x1='38.99' y1='44.67' x2='63.78' y2='44.67' />
               <line className='cls-1' x1='38.99' y1='53.35' x2='63.78' y2='53.35' />
               <line className='cls-1' x1='38.99' y1='62.03' x2='50.55' y2='62.03' />
               <path
                  className='cls-2'
                  d='M71.73,53.4l-13.03,14.48c-.59.66-.1,1.67.82,1.67h0c.59,0,1.08.45,1.08,1.02v10.27c0,.56.48,1.02,1.08,1.02h21.74c.59,0,1.08-.45,1.08-1.02v-10.27c0-.56.48-1.02,1.08-1.02h0c.92,0,1.42-1.01.82-1.67l-13.03-14.48c-.43-.48-1.21-.48-1.64,0Z'
               />
            </g>
         </g>
      </g>
   </Icon>
);

export default IcHome;
